<script setup>
import { ref } from "vue";

const title = "Workspaces";
const text = "Superadmin";
const text1 = "Tenant Workspaces";

const search = ref("");
const statusFilter = ref("");
const tableRef = ref(null);

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

function reloadTable() {
  tableRef.value?.reload?.();
}
</script>

<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper dq-platform">
    <div class="content">
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions">
          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <div>
            <h5 class="mb-1">Tenant Workspaces</h5>
            <p class="text-muted small mb-0">
              Map each company to its workspace URL and MySQL database name
              (<code>donequic_tenant_…</code>.
            </p>
          </div>
          <div class="d-flex align-items-center flex-wrap row-gap-2">
            <input
              v-model="search"
              type="search"
              class="form-control me-2"
              style="min-width: 260px"
              placeholder="Search company, slug, or database…"
            />
            <select v-model="statusFilter" class="form-select me-2" style="min-width: 160px">
              <option value="">All statuses</option>
              <option value="active">Active</option>
              <option value="migrating">Migrating</option>
              <option value="suspended">Suspended</option>
              <option value="pending">Pending</option>
            </select>
            <button type="button" class="btn btn-white" @click="reloadTable">
              <i class="ti ti-refresh me-1"></i>Refresh
            </button>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <tenants-table
              ref="tableRef"
              :search="search"
              :status-filter="statusFilter"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by
        <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>
